import React, { Suspense } from 'react';
import {
  ApolloClient, ApolloProvider, HttpLink, InMemoryCache,
} from '@apollo/client';

const { REACT_APP_API_URL } = process.env;

const httpLink = new HttpLink({ uri: REACT_APP_API_URL });

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache({
    addTypename: true,
    typePolicies: {
      Campaign: {
        keyFields: ['slug'],
      },
    },
  }),
});

const ApolloWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={null}>
    <ApolloProvider client={client}>
      {children}
    </ApolloProvider>
  </Suspense>
);

export default ApolloWrapper;
